var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIcondashboardpausedwhite = function SvgIcondashboardpausedwhite(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Dashboard/Notifications/Paused.NotificationTrayTab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Dashboard/Notifications/Paused.NotificationTrayTab",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58,1 L58,61 L39,61 L39,1 L58,1 Z M23,1 L23,61 L4,61 L4,1 L23,1 Z",
    id: "BG",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6333333,0 C23.2040276,0 23.6666667,0.462639092 23.6666667,1.03333333 L23.6666667,60.9666667 C23.6666667,61.5373609 23.2040276,62 22.6333333,62 L4.03333333,62 C3.46263909,62 3,61.5373609 3,60.9666667 L3,1.03333333 C3,0.462639092 3.46263909,0 4.03333333,0 L22.6333333,0 Z M57.9666667,0 C58.5373609,0 59,0.462639092 59,1.03333333 L59,60.9666667 C59,61.5373609 58.5373609,62 57.9666667,62 L39.3666667,62 C38.7959724,62 38.3333333,61.5373609 38.3333333,60.9666667 L38.3333333,1.03333333 C38.3333333,0.462639092 38.7959724,0 39.3666667,0 L57.9666667,0 Z M21.666,2 L5,2 L5,60 L21.666,60 L21.666,2 Z M57,2 L40.333,2 L40.333,60 L57,60 L57,2 Z",
    id: "Pause",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIcondashboardpausedwhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.dashboard.paused.white.8143e4273165ef9783148e17d0598d79.svg";